import { useEffect, useState } from 'react';

// This component loads the static landing.html content inline at "/"
// without changing the URL - preserving SEO benefits of static HTML
const LandingRedirect = () => {
  const [html, setHtml] = useState(null);
  const [skipRender, setSkipRender] = useState(false);

  useEffect(() => {
    // Only skip if server has rendered landing.html directly (production scenario)
    // Check for data-landing attribute which we added to landing.html body
    const serverRenderedLanding = document.body.hasAttribute('data-landing');
    
    if (serverRenderedLanding) {
      console.log('Server-rendered landing detected, skipping React render');
      setSkipRender(true);
      return;
    }

    // In preview/development, always fetch and render landing.html
    fetch('/landing.html')
      .then(res => res.text())
      .then(text => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, 'text/html');
        
        // Get styles from head
        const styles = Array.from(doc.head.querySelectorAll('style'))
          .map(el => el.innerHTML)
          .join('\n');
        
        // Get body content
        const bodyContent = doc.body.innerHTML;
        
        setHtml({ styles, bodyContent });
      })
      .catch(err => {
        console.error('Failed to load landing page:', err);
      });

    return () => {
      setHtml(null);
    };
  }, []);

  // If server already rendered landing, don't duplicate
  if (skipRender) {
    return null;
  }

  if (!html) {
    return (
      <div style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #0f172a 100%)'
      }} />
    );
  }

  return (
    <div id="landing-container">
      <style>{html.styles}</style>
      <div dangerouslySetInnerHTML={{ __html: html.bodyContent }} />
    </div>
  );
};

export default LandingRedirect;
